import {
  Button,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ProductInsertUpdateModal from "./productInsertUpdateModal";
import { getProducts, updateProductStatus } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import {
  AddCircleOutline,
  AssignmentReturn,
  AssignmentReturnOutlined,
  EditSharp,
  HistorySharp,
  TrendingUp
} from "@mui/icons-material";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import Label from "../../../components/Label";
import StockInsertUpdateModal from "../StockIn/stockInsertUpdateModal";
import ProductHistory from "./productHistory";
import AssignProductModal from "./assignProductModal";
import { Routes } from "src/constant/api_url";
import AssignProductToMemberModal from "./assignProductToMemberModal";
import { useNavigate } from "react-router-dom";
import ReturnProductModal from "./returnProductModal";
import CustomLoader from "src/commonComponents/CustomLoader";
import { useStockUser, useCityStock } from "../CityStockReport/CityStockContext";

export default function Index() {
  const navigate = useNavigate();
  const user = useStockUser();
  const cityStockCtx = useCityStock();

  const [addEditModal, setAddEditModal] = useState(false);
  const [stockAddModal, setStockAddModal] = useState(false);
  const [modalType, setModalType] = useState("Add");
  const [productList, setProductList] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [productHistoryPage, setProductHistoryPage] = useState(false);
  const [assignProductModal, setAssignProductModal] = useState(false);
  const [returnProductModal, setReturnProductModal] = useState(false);
  // const [assignProductToMemberModal, setAssignProductToMemberModal] = useState(false);
  const [filterData, setFilterData] = useState({ search: "", p_type: -1 });

  const toggleAddEditModal = () => setAddEditModal(!addEditModal);
  const toggleStockAddModal = () => setStockAddModal(!stockAddModal);
  const toggleProductHistoryPage = () => setProductHistoryPage(!productHistoryPage);
  const toggleAssignProductModal = () => setAssignProductModal(!assignProductModal);
  const toggleReturnProductModal = () => setReturnProductModal(!returnProductModal);
  // const toggleAssignProductToMemberModal = () =>
  //   setAssignProductToMemberModal(!assignProductToMemberModal);

  const handleGetProducts = async (filterdata) => {
    setLoader(true);
    const resp = await getProducts({
      ...filterdata,
      city_id: user?.city_id,
      u_type: user?.u_type,
      p_user_id: user?.p_user_id
    });
    setLoader(false);
    if (resp.status == 1) {
      setProductList(resp?.data?.data);
    }
  };

  const handleChangeStatus = async (data) => {
    setLoader(true);
    await updateProductStatus({
      p_id: data.p_id,
      p_status: data.p_status
    }).then((resp) => {
      setLoader(false);
      if (resp.status == 1) {
        let notify = notification({
          type: "success",
          message: "Product status updated successfully"
        });
        handleGetProducts();
        notify();
      }
    });
  };

  const columns = [
    { name: "No", selector: (row, index) => index + 1, width: "70px" },
    {
      name: "Product Name.",
      wrap: true,
      selector: (row) => row?.p_name,
      sortable: true
    },
    {
      name: "Price",
      wrap: true,
      selector: (row) => row?.p_price,
      sortable: true
    },
    {
      name: "City Price",
      wrap: true,
      selector: (row) => row?.p_city_price,
      sortable: true
    },
    {
      name: "Product Type",
      wrap: true,
      selector: (row) =>
        row?.p_type === 0 ? "Product" : row?.p_type === 1 ? "Pin" : row?.p_type === 2 ? "Welcome Kit" : "-",
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      width: "100px",
      selector: (row) => (
        <>
          <Tooltip title="Edit Product">
            <IconButton
              onClick={() => {
                setModalType("Edit");
                setRowData(row);
                toggleAddEditModal();
              }}
            >
              <EditSharp color="warning" />
            </IconButton>
          </Tooltip>
        </>
      )
    },
    {
      name: "Status",
      wrap: true,
      selector: (row) => (
        <>
          {row.p_status == 1 ? (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="success"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "16px"
                  }}
                >
                  Active
                </Label>

                {/* <Button
                  variant="contained"
                  onClick={() => {
                    !loader && handleChangeStatus({ p_id: row.p_id, p_status: 0 });
                  }}
                  style={{ background: "#ff4842" }}
                >
                  Deactive
                </Button> */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    !loader && handleChangeStatus({ p_id: row.p_id, p_status: 0 });
                  }}
                  disabled={loader}
                  startIcon={loader && <CircularProgress size={20} color="inherit" />}
                >
                  Deactive
                </Button>
              </div>
            </>
          ) : (
            <>
              <div style={{ margin: "10px 0" }}>
                <Label
                  variant="ghost"
                  color="error"
                  style={{
                    marginBottom: "10px",
                    display: "flex",
                    fontSize: "14px"
                  }}
                >
                  Deactive
                </Label>

                {/* <Button
                  variant="contained"
                  onClick={() => {
                    !loader && handleChangeStatus({ p_id: row.p_id, p_status: 1 });
                  }}
                >
                  Active
                </Button> */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    !loader && handleChangeStatus({ p_id: row.p_id, p_status: 1 });
                  }}
                  disabled={loader}
                  startIcon={loader && <CircularProgress size={20} color="inherit" />}
                >
                  Active
                </Button>
              </div>
            </>
          )}
        </>
      )
    }
  ];

  useEffect(() => {
    handleGetProducts(filterData);
  }, []);

  return (
    <>
      {!productHistoryPage ? (
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={2}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  Products
                </Typography>
              </Stack>
            </Grid>
            <Grid
              item
              xs={user?.u_type === 0 || (user?.u_type === 2 && user?.p_user_id === 1) ? 8 : 10}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 2
              }}
            >
              <FormControl size="small" sx={{ width: 200 }}>
                <InputLabel id="product-type-label">Product Type</InputLabel>
                <Select
                  labelId="product-type-label"
                  id="product-type-select"
                  value={filterData.p_type}
                  label="Product Type"
                  onChange={(e) => {
                    setFilterData({ ...filterData, p_type: e.target.value });
                  }}
                >
                  <MenuItem value={-1}>All</MenuItem>
                  <MenuItem value={0}>Product</MenuItem>
                  <MenuItem value={1}>Pin</MenuItem>
                  <MenuItem value={2}>Welcome Kit</MenuItem>
                </Select>
              </FormControl>
              <TextField
                size="small"
                label="Search"
                name="search"
                autoComplete="off"
                sx={{ width: 250 }}
                onChange={(e) => {
                  setFilterData({ ...filterData, search: e.target.value });
                }}
                value={filterData.search || ""}
              />
              <Button variant="contained" onClick={() => handleGetProducts(filterData)}>
                Search
              </Button>
              <Button
                variant="contained"
                color="inherit"
                onClick={() => {
                  handleGetProducts({ search: "", p_type: -1 });
                  setFilterData({ search: "", p_type: -1 });
                }}
              >
                Clear
              </Button>
            </Grid>
            {user?.u_type === 0 || (user?.u_type === 2 && user?.p_user_id === 1) ? (
              <Grid item xs={2} sx={{ marginTop: "5px" }}>
                <Button
                  onClick={() => {
                    toggleAddEditModal();
                    setModalType("Add");
                  }}
                  style={{ float: "right" }}
                  variant="contained"
                >
                  {/* Add Product */}
                  Add Product
                  {/* {step == 1 ? "Add Pin" : "Back"} */}
                </Button>
              </Grid>
            ) : (
              ""
            )}
          </Grid>

          {/* <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
          <DataTable
            pagination
            highlightOnHover
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={(p) => setPage(p)}
            onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
            columns={columns}
            data={productList != null ? productList : []}
          /> 
        </Card> */}

          <Grid container spacing={3} marginTop="10px">
            {loader ? (
              <CustomLoader />
            ) : productList?.length > 0 ? (
              productList.map((item) => (
                <Grid item xs={12} sm={6} md={4} lg={4} key={item.p_id}>
                  <Card
                    sx={{
                      position: "relative",
                      borderRadius: 2.5,
                      boxShadow:
                        "0px -1px 0px 1px rgb(28 71 102 / 18%), 0px 4px 5px 0px rgb(28 71 102 / 0%), 0px 1px 10px 0px rgb(28 71 102 / 73%)",

                      transition: "0.3s",
                      "&:hover": { boxShadow: 8, transform: "translateY(-4px)" },
                      // backgroundColor: "#1C4766",
                      // backgroundImage: "linear-gradient(207deg, #1c4766f5 0%, #0c53b773 100%)",
                      overflow: "hidden"
                    }}
                  >
                    {/* Add Quantity Button (Top Right Corner) */}
                    {/* <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8
                    }}
                  >
                    <Tooltip title="Add Stock">
                      <IconButton
                        color="primary"
                        size="small"
                        sx={{
                          backgroundColor: "#ffffffb3",
                          "&:hover": { backgroundColor: "#d1ecff" }
                        }}
                        onClick={() => {
                          toggleStockAddModal();
                          setModalType("Add");
                        }}
                      >
                        <AddCircleOutline fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Edit Product">
                      <IconButton
                        color="warning"
                        size="small"
                        sx={{
                          backgroundColor: "#ffffffb3",
                          "&:hover": { backgroundColor: "#ffe6cc" }
                        }}
                        onClick={() => {
                          setModalType("Edit");
                          setRowData(item);
                          toggleAddEditModal();
                        }}
                      >
                        <EditSharp fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Stack> */}

                    <Stack
                      direction="row"
                      spacing={2}
                      alignItems="center"
                      p={2}
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate("/pininmemberlist", { state: { ...item, ...(cityStockCtx ? { cityUser: user } : {}) } });
                      }}
                    >
                      {/* Left: Product Image */}
                      <CardMedia
                        component="img"
                        image={
                          item.p_image
                            ? `${Routes.API_HOSTNAME}products-image/${item.p_image}`
                            : "https://dummyimage.com/200x200/cccccc/000000&text=Product"
                        }
                        alt={item.p_name}
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: 2,
                          objectFit: "contain",
                          backgroundColor: "#fff"
                        }}
                      />

                      {/* Right: Product Info */}
                      <CardContent
                        sx={{
                          flex: 1,
                          padding: "0 !important",
                          wordBreak: "break-word"
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight={700} color="#212B36">
                          {item.p_name}
                        </Typography>

                        {user?.u_type === 1 || (user?.u_type === 2 && user?.p_user_id !== 1) ? (
                          <Typography
                            variant="body2"
                            color="#212B36"
                            mt={0.1}
                            sx={{ fontSize: "0.80rem" }}
                          >
                            Pending Stock:{" "}
                            <strong style={{ color: "#212B36" }}>{item.pending_qty ?? 0}</strong>
                          </Typography>
                        ) : (
                          ""
                        )}
                        <Typography
                          variant="body2"
                          color="#212B36"
                          mt={0.1}
                          sx={{ fontSize: "0.80rem" }}
                        >
                          Current Stock:{" "}
                          <strong style={{ color: "#212B36" }}>{item.approved_qty ?? 0}</strong>
                        </Typography>
                        {user?.u_type === 0 || (user?.u_type === 2 && user?.p_user_id === 1) ? (
                          <Typography
                            variant="body2"
                            color="#212B36"
                            mt={0.1}
                            sx={{ fontSize: "0.80rem" }}
                          >
                            Return Stock:{" "}
                            <strong style={{ color: "#212B36" }}>{item.p_return_qty ?? 0}</strong>
                          </Typography>
                        ) : (
                          ""
                        )}
                        {/* {user?.u_type == 0 ? ( */}
                        <>
                          <Typography
                            variant="body2"
                            color="#212B36"
                            mt={0.1}
                            sx={{ fontSize: "0.80rem" }}
                          >
                            Eligible Member:{" "}
                            <strong style={{ color: "#212B36" }}>
                              {item.member_eligibility_counter ?? 0}
                            </strong>
                          </Typography>
                          <Typography
                            variant="body2"
                            color="#212B36"
                            mt={0.1}
                            sx={{ fontSize: "0.80rem" }}
                          >
                            Assign Member:{" "}
                            <strong style={{ color: "#212B36" }}>
                              {item.member_assign_counter ?? 0}
                            </strong>
                          </Typography>
                        </>
                        {/* ) : (
                          ""
                        )} */}
                      </CardContent>
                    </Stack>

                    {/* Bottom: Action Buttons */}
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      px={2}
                      sx={{
                        borderTop: "1px solid #d6e2ef",
                        backgroundColor: "#f8fbff"
                      }}
                    >
                      {user?.u_type === 0 || (user?.u_type === 2 && user?.p_user_id === 1) ? (
                        <>
                          <Tooltip title="Edit Product">
                            <IconButton
                              color="warning"
                              onClick={() => {
                                setModalType("Edit");
                                setRowData(item);
                                toggleAddEditModal();
                              }}
                            >
                              <EditSharp />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Add Stock">
                            <IconButton
                              color="success"
                              onClick={() => {
                                setModalType("Add");
                                setRowData(item);
                                toggleStockAddModal();
                              }}
                            >
                              <AddCircleOutline />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Assign Stock">
                            <IconButton
                              color="primary"
                              onClick={() => {
                                setRowData(item);
                                if (
                                  user?.u_type === 0 ||
                                  (user?.u_type === 2 && user?.p_user_id === 1)
                                )
                                  toggleAssignProductModal();
                                // else toggleAssignProductToMemberModal();
                              }}
                            >
                              <TrendingUp />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="View History">
                            <IconButton
                              color="info"
                              onClick={() => {
                                setRowData(item);
                                toggleProductHistoryPage();
                                // setModalType("Edit");
                                // toggleAddEditModal();
                              }}
                            >
                              <HistorySharp />
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          <Tooltip title="Assign Guest">
                            <IconButton
                              color="primary"
                              onClick={() => {
                                setRowData(item);
                                toggleAssignProductModal();
                                // else toggleAssignProductToMemberModal();
                              }}
                            >
                              <TrendingUp />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Assign Member">
                            <IconButton
                              color="primary"
                              onClick={() => {
                                navigate("/pininmemberlist", { state: { ...item, ...(cityStockCtx ? { cityUser: user } : {}) } });
                              }}
                            >
                              <PersonAddAltIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Return Stock">
                            <IconButton
                              color="primary"
                              onClick={() => {
                                setRowData({ ...item, city_id: user?.city_id });
                                toggleReturnProductModal();
                                // else toggleAssignProductToMemberModal();
                              }}
                            >
                              <AssignmentReturnOutlined />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="View History">
                            <IconButton
                              color="info"
                              onClick={() => {
                                setRowData(item);
                                toggleProductHistoryPage();
                                // setModalType("Edit");
                                // toggleAddEditModal();
                              }}
                            >
                              <HistorySharp />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </Stack>
                  </Card>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Typography variant="h6" color="text.secondary" textAlign="center" mt={4}>
                  No products available.
                </Typography>
              </Grid>
            )}
          </Grid>
        </Container>
      ) : (
        <ProductHistory
          productHistoryPage={productHistoryPage}
          setProductHistoryPage={setProductHistoryPage}
          rowData={rowData}
        />
      )}
      {addEditModal && (
        <ProductInsertUpdateModal
          addEditModal={addEditModal}
          setAddEditModal={setAddEditModal}
          toggleAddEditModal={toggleAddEditModal}
          rowData={rowData}
          setRowData={setRowData}
          modalType={modalType}
          handleGetProducts={handleGetProducts}
        />
      )}

      {stockAddModal && (
        <StockInsertUpdateModal
          addEditModal={stockAddModal}
          setAddEditModal={setStockAddModal}
          toggleAddEditModal={toggleStockAddModal}
          modalType={modalType}
          rowData={rowData}
          handleGetProducts={handleGetProducts}
          filterData={filterData}
        />
      )}

      {assignProductModal && (
        <AssignProductModal
          assignProductModal={assignProductModal}
          setAssignProductModal={setAssignProductModal}
          toggleAssignProductModal={toggleAssignProductModal}
          rowData={rowData}
          handleGetProducts={handleGetProducts}
        />
      )}
      {returnProductModal && (
        <ReturnProductModal
          returnProductModal={returnProductModal}
          toggleReturnProductModal={toggleReturnProductModal}
          rowData={rowData}
          handleGetProducts={handleGetProducts}
          filterData={filterData}
        />
      )}
      {/* {assignProductToMemberModal && (
        <AssignProductToMemberModal
          assignProductToMemberModal={assignProductToMemberModal}
          setAssignProductToMemberModal={setAssignProductToMemberModal}
          toggleAssignProductToMemberModal={toggleAssignProductToMemberModal}
          rowData={rowData}
          modalType="Add"
        />
      )} */}
    </>
  );
}
